import { Store, ActionTree, ActionContext } from 'vuex'
import { State } from './state'
import { StatsDeklaracjeService } from "@/services/stats-deklaracje.service";
import { ForceUpdateAndLastYear, ProductIdAndLastYear } from "@/pitprojekt/types";
import _ from 'lodash'


export async function updateAggregatedStatsDeklaracjeSum(store: ActionContext<State, any>, params: ForceUpdateAndLastYear) {
    store.commit('updatingAggregatedStatsDeklaracjeSum', params.forceUpdate);

    for (let index in store.rootState.SettingsModule.selectedProducts) {
        let productId: number = store.rootState.SettingsModule.selectedProducts[index];

        if (_.find(store.state.aggregatedStatsDeklaracjeSumBuffer, function(o) { return o.productId == productId; }) == undefined) {
            store.dispatch('getAggregatedStatsDeklaracjeSumBetweenDatesForProduct', {'productId': productId, 'lastYear': params.lastYear});
        }
        else
            store.commit('updatedAggregatedStatsDeklaracjeSum');
    }

}

export async function getAggregatedStatsDeklaracjeSumBetweenDatesForProduct(store: ActionContext<State, any>, params: ProductIdAndLastYear) {
    try {
        const aggregatedStatsDeklaracje = await StatsDeklaracjeService.getSumBetweenDates(params.productId, store.rootState.SettingsModule.dateFrom, store.rootState.SettingsModule.dateTo, params.lastYear);
        store.commit('loadedAggregatedStatsDeklaracjeSumForProduct', {'productId': params.productId, 'stat': aggregatedStatsDeklaracje.sum});
        if (store.state.aggregatedStatsDeklaracjeSumBuffer.length === store.rootState.SettingsModule.selectedProducts.length) {
            store.commit('updatedAggregatedStatsDeklaracjeSum');
        }
        return true;
    }
    catch (error) {
        return false;
    }
}


export async function getDetailedStatsDeklaracjeBetweenDatesForProduct(store: ActionContext<State, any>, params: ProductIdAndLastYear) {
    store.commit('loadingDetailedStatsDeklaracjeBetweenDatesForProduct');
    try {
        const detailedStatsDeklaracje = await StatsDeklaracjeService.getListBetweenDates(params.productId, store.rootState.SettingsModule.dateFrom, store.rootState.SettingsModule.dateTo, params.lastYear);
        store.commit('loadedDetailedStatsDeklaracjeForProduct', detailedStatsDeklaracje);

        return true;
    }
    catch (error) {
        return false;
    }
}


export default <ActionTree<State, any>> {
    updateAggregatedStatsDeklaracjeSum, getAggregatedStatsDeklaracjeSumBetweenDatesForProduct, getDetailedStatsDeklaracjeBetweenDatesForProduct
}
